(ns frontend.view.nev.zap-vault.model)

(def root-path [::state])

(def tab-documents :documents)
(def tab-analytics :analytics)
(def tab-configuration :configuration)
(def tab-disclaimer :disclaimer)
(def tab-permissions :permissions)

(def all-tabs #{tab-documents tab-analytics tab-configuration tab-disclaimer tab-permissions})

(def active-tab-key :active-tab)
(def active-tab-full-path (into root-path [active-tab-key]))

(def vault-id-key :vault-id)
(def vault-id-full-path (into root-path [vault-id-key]))

(def vault-config-id-key :vault-config-id)
(def vault-config-id-full-path (into root-path [vault-config-id-key]))

(def delete-attachment-key :delete-attachment)
(def delete-attachment-full-path (into root-path [delete-attachment-key]))

(def deleting-attachment?-key :deleting-attachment?)
(def deleting-attachment?-full-path (into root-path [deleting-attachment?-key]))

(def edit-attachment-key :edit-attachment)
(def edit-attachment-full-path (into root-path [edit-attachment-key]))

(def document-changes-key :document-changes)
(def document-changes-full-path (into root-path [document-changes-key]))

(def saving-edits?-key :saving-edits)
(def saving-edits?-full-path (into root-path [saving-edits?-key]))

(def optimistic-updates-key :optimistic-updates)
(def optimistic-updates-full-path (into root-path [optimistic-updates-key]))

(def activities-key :activities)
(def activities-full-path (into root-path [activities-key]))

(def config-changes-key :config-changes)
(def config-changes-full-path (into root-path [config-changes-key]))

(def vault-changes-key :vault-changes)
(def vault-changes-full-path (into root-path [vault-changes-key]))

(def processing?-key :processing?)
(def processing?-full-path (into root-path [processing?-key]))

(def preview?-key :preview)
(def preview?-full-path (into root-path [preview?-key]))

(def preview-confirmed?-key :preview-confirmed)
(def preview-confirmed?-full-path (into root-path [preview-confirmed?-key]))

(def uploading-logo-key :uploading-logo?)
(def uploading-logo-full-path (into root-path [uploading-logo-key]))
